import UpdatePassengerSeatsMutation from './UpdatePassengerSeatsMutation';

export default UpdatePassengerSeatsMutation;
